import React, { useEffect } from 'react';

import { api } from '@api/reduxApi';
import { BulkDeleteConfirmationModal } from '@components/CandidatesApp/CandidatesIndex/BulkDeleteConfirmationModal';
import { useToaster } from '@components/stores/toaster';

import { failedDelete } from './toasts';

export const ConfirmDeleteModal: React.FC<
  React.PropsWithChildren<{
    id: number;
    onCancel: () => void;
    onSuccess: () => void;
  }>
> = ({ id, onCancel, onSuccess }) => {
  const showToast = useToaster();
  const [destroyCandidate, { isSuccess, isError, isLoading }] = api.useDestroyCandidateMutation();

  useEffect(() => {
    if (isSuccess) {
      onSuccess();
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError) {
      showToast(failedDelete());
    }
  }, [isError]);

  async function handleConfirm(deletion_type: Candidate['deletion_type']) {
    try {
      await destroyCandidate({ id, deletion_type }).unwrap();
    } catch (error) {
      console.error(error);
    }
  }

  return <BulkDeleteConfirmationModal count={1} onConfirm={handleConfirm} onCancel={onCancel} loading={isLoading} />;
};
